import { styled } from '@naan/stitches.config';

export const Sticky = styled('div', {
  $$headerHeight: '56px',
  $$storyStatusHeight: '56px',
  $$assignmentBannerHeight: '64px',
  position: 'sticky',
  zIndex: 1,
});
